query CheckCidActivated($baseSiteId: BaseSiteId!, $cid: String!) {
  checkCidActivated(baseSiteId: $baseSiteId, cid: $cid)
}
